import { Company } from '../../../types/company/Company'

const companyGroupEndpoints = {
  group: (companyId: string) => `/companies/${companyId}/group` as const,
  subsidiaries: (companyId: string) => `/companies/${companyId}/group/subsidiaries` as const,
  subsidiaryDetail: (companyId: string, subsidiaryId: Company['id']) =>
    `/companies/${companyId}/group/subsidiaries/${subsidiaryId}` as const,
  subsidiaryAcquisitions: (companyId: string, subsidiaryId: Company['id']) =>
    `/companies/${companyId}/group/subsidiaries/${subsidiaryId}/acquisitions` as const,
  subsidiaryOrder: (companyId: string) => `/companies/${companyId}/group/subsidiaries/order` as const
}

export default companyGroupEndpoints
